// extracted by mini-css-extract-plugin
module.exports = {"userProfile":"_52f1c5","userProfileOverlay":"d9d409","userDetails":"_5377eb","editProfilePhotoModalContainer":"f3fd53"};